"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChildNode = void 0;
exports.isChildNode = function (parent, child) {
    if (parent === child)
        return true;
    var node = child.parentNode;
    while (node !== null) {
        if (node === parent)
            return true;
        node = node.parentNode;
    }
    return false;
};
//# sourceMappingURL=dom.js.map